import { LitElement, html, property } from 'lit-element'
import { bemBlock } from '@polleverywhere/bem-helpers'
import { register } from '@polleverywhere/hmr-custom-element'
import { validate as validateViewport } from './viewports'
import './divider.scss'

/**
 * Renders a divider between navigation items as a separator.
 *
 * @element pe-navigation-divider
 *
 * @prop {string} viewports - List of viewport sizes separated by a single
 *  whitespace. When the root `viewport` property is set to a specific size,
 *  items with the size included in this list will remain visible. Otherwise,
 *  they are hidden. Valid values are: `sm`,`md`,`lg`.
 */
export default class Divider extends LitElement {
  static get tagName () { return 'pe-navigation-divider' }

  @property({ type: String, reflect: true })
  get viewports () {
    return this._viewports
  }

  set viewports (values) {
    const oldValues = this._viewports
    const newSet = new Set(values?.trim().split(' '))
    const newValues = [...newSet].join(' ') || null
    if (oldValues === newValues) return

    // If set is changing, validate each viewport value.
    newSet.forEach(viewport => validateViewport(viewport))

    this._viewports = newValues
    this.requestUpdate('viewports', oldValues)
  }

  createRenderRoot () { return this }

  render () {
    return html`
      <hr class=${bem()} />
    `
  }
}

const bem = bemBlock(Divider.tagName)
register(module, Divider.tagName, Divider)
